<template>
  <v-card
    :style="`height: calc(100vh - 74px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
    class="col-12 pb-0"
  >
    <v-row
      class="mx-0 px-2"
    >
      <select-project
        v-model="project"
        class="package-project_selector"
        style="max-width: 160px"
      >
      </select-project>
      <v-select
        class="col-2 pb-0"
        label="Type"
        multiple
        :items="type_list"
        v-model="types"
        style="max-width: 200px"
      >
        <template v-slot:selection="{ item: chipItem, index }">
          <div style="max-width: 180px" class="v-select__selection v-select__selection--comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < chipCount - 1 ? ',' : '' }} &nbsp;</div>
          <span
            class="caption float-right"
            v-if="index === chipCount && (types || []).length > chipCount"
          >(+{{ (types || []).length - chipCount }} others)</span>
        </template>
      </v-select>

      <v-autocomplete
        :loading="benefitListLoading"
        class="col-3 pb-0"
        style="max-width: 320px"
        label="Benefit"
        multiple
        auto-select-first
        :items="benefit_list"
        v-model="benefit_ids"
      >
        <template v-slot:selection="{ item: chipItem, index }">
          <div style="max-width: 180px" class="v-select__selection v-select__selection--comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < chipCount - 1 ? ',' : '' }} &nbsp;</div>
          <span
            class="caption float-right"
            v-if="index === chipCount && (benefit_ids || []).length > chipCount"
          >(+{{ (benefit_ids || []).length - chipCount }} others)</span>
        </template>
        <template v-slot:item="{attrs, on, item}">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-action>
              <v-simple-checkbox
                :value="attrs.inputValue"
              />
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                <span v-html="item.text"></span>
                <small class="float-right">({{ item.value }})</small>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>

      <date-picker
        v-model="from"
        label="Date From"
        style="max-width: 140px"
      />

      <date-picker
        v-model="to"
        label="Date To"
        style="max-width: 140px"
      />

      <v-btn
        color="info"
        class="mt-3 ml-3"
        :loading="loading"
        :disabled="loading"
        @click="search"
      >
        Search
      </v-btn>
      <export :fields="exportFields" without_sg :data="items" report-name="Packages for Approve" :project="project" />
      <v-spacer />
      <v-btn
        :color="approveColor"
        class="mt-3 white--text"
        width="186"
        :loading="loading"
        :disabled="loading"
        @click="approve"
      >
        {{ approveText }}
      </v-btn>

    </v-row>

    <v-data-table
      :class="`bonus-tools-dt ${$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) ? 'padding-footer' : ''}`"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      fixed-header
      item-key="package_id"
      :expanded.sync="expanded"
      show-select
      v-model="selected"
      selectable-key="package_id"
      show-expand
      :options.sync="options"
      :items="filteredItems"
      :footer-props="{'items-per-page-options':[ 50, 100, 200 ]}"
      :items-per-page="50"
      :height="`calc(100vh - 215px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
          <td></td>
          <td
            v-for="header in headers"
            :key="header.value"
            style="height: auto"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="ma-0 pa-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="ma-0 pa-0"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{width: (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>


      <template v-slot:item.login="{ item, header }">
        <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
      </template>
      <template v-slot:item.account_id="{ item, header }">
        <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
      </template>

      <template v-slot:expanded-item="{ headers , item }">
        <td :colspan="headers.length">

          <v-row justify="center" class="col-12 px-0 mx-0">
            <template class="pa-0 ma-0" v-for="(choice, i) in item.rules.choices">
              <v-divider v-if="i > 0" class="my-4" />
              <v-card v-for="(bonus, k) in choice.bonuses" :key="'bt-choice-bonus-' + k" class="col-6 align-center mt-2">
                <v-card-text :class="{'pt-2': true, 'pb-2': bonus.type == 'loyalty'}">
                  <v-row>
                    <v-text-field
                      class="col-3"
                      label="Type"
                      :value="bonus.type"
                      hide-details
                      readonly
                    />

                    <v-text-field
                      class="col-2"
                      label="Amount"
                      :value="bonus.amount || (bonus.percent + '%')"
                      :suffix="['casino','sport','cash_bonus', 'loyalty'].includes(bonus.type) && bonus.amount ? item.currency : false"
                      hide-details
                      readonly
                    />

                    <v-text-field
                      class="col-2"
                      v-if="bonus.hasOwnProperty('wager')"
                      label="Wager"
                      :value="bonus.wager"
                      hide-details
                      readonly
                    />

                    <v-select
                      v-if="bonus.hasOwnProperty('game_id')"
                      class="col-5"
                      label="Game"
                      :value="bonus.game_id"
                      :prefix="'#' + bonus.game_id"
                      :items="games"
                      hide-details
                      readonly
                    />

                    <v-checkbox
                      :class="{'mr-3': true, 'mt-0': bonus.hasOwnProperty('game_id'), 'ml-3': bonus.hasOwnProperty('game_id')}"
                      v-if="bonus.hasOwnProperty('brand_exclusive')"
                      label="Exclusive Brand"
                      :value="bonus.brand_exclusive"
                      hide-details
                      readonly
                    />

                    <v-checkbox
                      :class="{'mt-0': bonus.hasOwnProperty('game_id')}"
                      v-if="bonus.hasOwnProperty('game_exclusive')"
                      label="Exclusive Game"
                      :value="bonus.game_exclusive"
                      hide-details
                      readonly
                    />
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-row>
        </td>
      </template>

      <template v-slot:item.action="{ item }">
        <div style="white-space: nowrap">
          <v-icon small @click="selected = item">
            edit
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
  .package-project_selector {
    max-width: 300px;
  }
</style>


<script>
  import { filter, get, map } from 'lodash'
  import { API } from '@/utils/api'
  import moment from 'moment'
  import Benefits from '@/components/bonus-tools/Benefits'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {

    components: {
      SelectProject,
      DatePicker,
      Benefits,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      benefitListLoading: false,
      loading: false,

      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      selected: [],

      project: null,
      expanded: [],
      games: [],
      items: [],
      total: 0,
      benefit_list: [],
      benefit_ids: [],
      chipCount: 1,

      type_list: [
        { text: 'Period', value: 'period' },
        { text: 'Autobonus', value: 'autobonus' },
        { text: 'Promotional', value: 'promo' },
        { text: 'Cashback', value: 'cashback' },
        { text: 'Retention', value: 'retention' },
        { text: 'Achievement', value: 'achievement' },
        { text: 'Journey', value: 'journey' },
        { text: 'Lucky Box', value: 'luckybox' },
      ],
      types: [],

      filters: {
        package_id: { data: [], type: 'text', width: '120px' },
        login: { data: [], type: 'text' },
        currency: { data: [], type: 'select', width: '100px' },
        // 'rules.recurring': { data: [], type: 'select' },
        manual_check: { data: [], type: 'select', width: '100px' },
        // ref_id: { data: [], type: 'text' },
        // name: { data: [], type: 'text' },
        // enabled: { data: [], type: 'select', values: [ { text: 'Yes', value: 1 }, { text: 'No', value: 0 } ] },
      },
      headers: [
        { text: 'ID', value: 'package_id' },
        { text: 'Login', value: 'login' },
        { text: 'Currency', value: 'currency' },
        { text: 'Type', value: 'rules.type', sortable: false },
        { text: 'Recurring', value: 'rules.recurring', sortable: false },
        { text: 'Manual Check', value: 'manual_check', sortable: false },
        { text: 'Status', value: 'status' },
        { text: 'Created', value: 'created' },
        { text: 'Updated', value: 'updated' },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
        // { text: '', value: 'action' },
      ],
      options: {},
    }),

    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },
      approveColor: function () {
        return this.selected.length > 0 ? 'success' : 'teal darken-1'
      },
      approveText: function () {
        return this.selected.length > 0 ? 'Approve selected' : 'Approve All'
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      project: {
        handler () {
          this.loadBenefitList()
        },
      },
      types: {
        handler () {
          this.loadBenefitList()
        },
      },
      options: {
        handler () {
          this.search()
        },
        deep: true
      },
    },

    methods: {

      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },

      loadBenefitList: function () {
        if (this.benefitListLoading == true || !this.types) {
          return
        }
        this.benefitListLoading = true
        try {
          API.call('/bonus_tools/dictionary/benefit_list.json', {
            types: this.types,
          }, null, this.project).then(resp => {

            this.benefit_list = get(resp, 'data', [])

            // if (this.benefit_list.length > 0) {
            //   this.benefit_ids.push(this.benefit_list[0].value)
            // }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.benefitListLoading = false
          })
        } catch (e) {
          this.benefitListLoading = false
          console.log(e)
        }
      },

      search: function () {
        if (this.loading == true) {
          return
        }
        this.loading = true
        try {
          API.call('/bonus_tools/packages_list.json', {
            ...this.options,
            benefit_ids: this.benefit_ids,
            status: 'new',
            types: this.types,
            from: this.from,
            to: this.to
          }, null, this.project).then(resp => {

            this.games = get(resp, 'games', [])
            this.items = get(resp, 'data', [])
            if (get(resp, 'total', false)) {
              this.total = resp.total
            }
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      approve: function () {
        if (this.loading == true) {
          return
        }
        this.loading = true
        API.call('/bonus_tools/package_approve.json', {
          ...this.options,
          benefit_ids: this.benefit_ids,
          status: 'new',
          types: this.types,
          from: this.from,
          to: this.to,
          package_ids: this.selected.length > 0 ? map(this.selected, 'package_id') : 'all'
        }, null, this.project).then(resp => {
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
          this.search()
        })
      },
    }
  }
</script>
